import { render, staticRenderFns } from "./NotesComponent.vue?vue&type=template&id=f14de684&scoped=true"
import script from "./NotesComponent.vue?vue&type=script&lang=js"
export * from "./NotesComponent.vue?vue&type=script&lang=js"
import style0 from "./NotesComponent.vue?vue&type=style&index=0&id=f14de684&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14de684",
  null
  
)

export default component.exports